import { render, staticRenderFns } from "./ShowLocalTime.vue?vue&type=template&id=149fadb4&"
import script from "./ShowLocalTime.vue?vue&type=script&lang=js&"
export * from "./ShowLocalTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports